const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;

  observer.unobserve(productRecommendationsSection);

  const collectionHandle = productRecommendationsSection.dataset.collection;
  var  url = productRecommendationsSection.dataset.url;

  // if (px1024) {
  //   var url = productRecommendationsSection.dataset.url.split('&limit')[0] + '&limit=4';
  // } else {
  //   var  url = productRecommendationsSection.dataset.url;
  // }

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector(".recommendations");

      if (collectionHandle) {
        let cards = html.querySelectorAll(".product-card");
        cards.forEach((card) => {
            card.querySelectorAll(".product-card__link").forEach((link) => {
                link.href = link.href.replace("/products", `/collections/${collectionHandle}/products`);
            });
        });
      }
      if (recommendations && recommendations.innerHTML.trim().length) {

        productRecommendationsSection.innerHTML = recommendations.innerHTML;
        cartScripts();
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

const productRecommendationsSection = document.querySelector(
  "section.recommendations"
);
const observer = new IntersectionObserver(handleIntersection, {
  rootMargin: "0px 0px 200px 0px",
});

observer.observe(productRecommendationsSection);
